import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const ttpRegistriesUrl = `${SERVER_API}/ttp-registries`;

export const ttpEventHistoryUrl = `${ttpRegistriesUrl}/ttp-event-history`;

export const organiztionsUrl = `${ttpRegistriesUrl}/ttp-organizations`;

export const economicalRelationshipsUrl = `${ttpRegistriesUrl}/economic-agreement`;

export const TTP = {
  LIST: {
    method: 'GET',
    url: `${organiztionsUrl}`,
  },

  INFO(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpRegistriesUrl}/ttp/${id}/info`,
    };
  },
  FINAL_INDICATORS_REPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/final-indicators-legal-entities`,
  } as IEndpointData,
  ACTIVITIES_TYPES_REPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/activities-types`,
  } as IEndpointData,
  ORGANIZATION_INCLUDE_EXCLUDE_REPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/organization-include-exclude`,
  } as IEndpointData,
  STATISTIC_DATA_REPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/statistic-data`,
  } as IEndpointData,
  TOJ_DATA_QUALITY: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/toj-data-quality`,
  } as IEndpointData,
  AGE_CATEGORIES_REPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/age-categories`,
  } as IEndpointData,
  DEMOGRAPHY_REPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/demography`,
  } as IEndpointData,
  STRUCTURE_TTP: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/structure-ttp`,
  } as IEndpointData,
  STRUCTURE_THD: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/structure-thd`,
  } as IEndpointData,
  STRUCTURE_TTP_COMMUNES: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/structure-ttp-communes`,
  } as IEndpointData,
  ORGANIZATION_ACTIVITIES: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/organization-activities`,
  } as IEndpointData,
  COUNT_DEER: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/count-deer`,
  },
  DEER_SLAUGHTER: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/deer-slaughter`,
  },
  DEER_HERD: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/deer-herd`,
  },
  DEER_HERD_FAST: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/deer-herd-fast`,
  },
  REGISTRY_TTP: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/registry-ttp`,
  } as IEndpointData,
  EMPLOYEES_TTP: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/employees-of-organizations`,
  } as IEndpointData,
  ORGANIZATIONS: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/organizations`,
  },
  DSZN_XML_EXPORT: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/person/dszn/export`,
  },
  ISSUED_TMC: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/issued-tmc`,
  },
  ISSUED_TMC_TASK: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/issued-tmc-task`,
  },
  ISSUED_TMC_BY_QUARTER: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/issued-tmc-by-quarter`,
  },
  DEATH_CERTIFICATE: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/death-certificate`,
  },
  FAMILIES_TTP: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/families-ttp`,
  },
  BIRTH_CERTIFICATE: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/birth-certificate`,
  },
  ACCEPTED_TMC: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/accepted-tmc`,
  },
  MSP_KMNS: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/msp-kmns`,
  },
  REGISTER_ISSUING_CERTIFICATES: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/register-issuing-certificates`,
  },
  ACCEPTED_ISSUES: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/accepted-issues`,
  },
  ISSUE_REGISTER: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/issue-register`,
  },
  REGISTER_ISSUING: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/register-issuing`,
  },
  EDUCATION_SCH: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/education-sch`,
  },
  EDUCATION_SPO: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/education-spo`,
  },
  PAYMENTS_GSM: {
    method: 'GET',
    url: `${ttpRegistriesUrl}/reports/payments-gsm`,
  },
};

export const TTP_PERSON = {
  LIST: {
    method: 'GET',
    url: `${organiztionsUrl}`,
  },
};

export const TTP_ORGANIZATION = {
  LIST: {
    method: 'GET',
    url: `${organiztionsUrl}`,
  },
  SHOW(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${organiztionsUrl}/${id.toString()}`,
    };
  },
  CREATE: {
    method: 'POST',
    url: `${organiztionsUrl}`,
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${organiztionsUrl}/${id.toString()}`,
    };
  },
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${organiztionsUrl}/${id.toString()}`,
    };
  },
  EXCLUDE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${organiztionsUrl}/${id.toString()}/exclude`,
    };
  },
};

export const identityDocumentsUrl = `${ttpRegistriesUrl}/person/identity-document`;

export const TTP_IDENTITY_DOCUMENT = {
  LIST: {
    method: 'GET',
    url: `${identityDocumentsUrl}`,
  },
  SHOW(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${identityDocumentsUrl}/${id.toString()}`,
    };
  },
  CREATE: {
    method: 'POST',
    url: `${identityDocumentsUrl}`,
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${identityDocumentsUrl}/${id.toString()}`,
    };
  },
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${identityDocumentsUrl}/${id.toString()}`,
    };
  },
};
